module.exports = __webpack_public_path__ + "static/assets/9f16b3cc3bd16bf75d0ab25031b360d4.svg";